module.exports = __webpack_public_path__ + "assets/media/s26.f04ae5dc.mp3";